import {useQuery} from '@tanstack/react-query';
import {STATION_SIDEBAR_QUERY_KEY} from '@/query/channel/menu/queryKeys';
import {MenuReqest} from '@/types/channel/menu/menu.schema';
import {getStationSubscriptionList} from '@/api/channel/menu';
import {mapSubscribeFanListSchemaToModel} from '@/types/channel/menu/menu.mapper';
import {SubscribeFanModel} from '@/types/channel/menu/menu.model';

const useStationSubscriptionListQuery = (
  params: MenuReqest,
  type: 'gift' | 'acc',
) => {
  return useQuery({
    queryKey: STATION_SIDEBAR_QUERY_KEY.SUBSCRIPTION_LIST(
      params?.streamerId,
      type,
    ),
    queryFn: async (): Promise<SubscribeFanModel[]> => {
      const response = await getStationSubscriptionList(
        params?.streamerId,
        type,
      );
      return response?.map(mapSubscribeFanListSchemaToModel);
    },
    enabled: false,
  });
};

export default useStationSubscriptionListQuery;
